import { useRef, useState } from "react";
import { Box, IconButton, List, ListItem, ListItemText, Paper, Popper } from "@mui/material";
import { P } from "theme/typography";
import { ArrowDropDown, Edit } from "@mui/icons-material";

interface Props {
  onEdit?: () => void;
  items: { id: number; name: string }[];
  accessType: "Lenses" | "Firms";
}

export const CollectUserAccessCell = ({ onEdit, items, accessType }: Props) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isHoveringDropdown, setIsHoveringDropdown] = useState(false);
  const [isHoveringPopper, setIsHoveringPopper] = useState(false);
  const anchorEl = useRef<HTMLElement>(null);
  const firstItem = items[0];

  return (
    <Box onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
      {items.length === 1 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <P>{firstItem?.name}</P>
          {onEdit !== undefined && (
            <IconButton
              onClick={onEdit}
              sx={{
                visibility: isHovering ? "visible" : "hidden",
              }}>
              <Edit />
            </IconButton>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onMouseLeave={() => setIsHoveringDropdown(false)}
          ref={anchorEl}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
            onMouseEnter={() => setIsHoveringDropdown(true)}>
            <P>
              {items.length} {accessType}
            </P>
            <ArrowDropDown />
          </Box>
          {onEdit !== undefined && (
            <IconButton
              onClick={onEdit}
              sx={{
                visibility: isHovering ? "visible" : "hidden",
              }}>
              <Edit />
            </IconButton>
          )}
        </Box>
      )}

      <Popper
        open={isHoveringDropdown || isHoveringPopper}
        anchorEl={anchorEl.current}
        placement="bottom-start"
        onMouseEnter={() => setIsHoveringPopper(true)}
        onMouseLeave={() => setIsHoveringPopper(false)}>
        <Paper sx={{ maxHeight: "300px", overflow: "auto" }}>
          <List sx={{ width: "100%" }}>
            {items.map((item) => (
              <ListItem key={item.id}>
                <ListItemText primary={item.name} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Popper>
    </Box>
  );
};
